import React, { useMemo, useState, useRef } from 'react'
import { Wrapper, ListItem, TextDetail, Panel, TextField, FileFieldIcon, TextFieldIcon, ModalComponent, SearchableSelectField } from '../../_components'
// import Table from '../_components/Table'
import Axios from 'axios'
// import Theme from '../Theme'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { FaAddressCard, FaUserAlt, FaEdit } from 'react-icons/fa'
import avatar from '../../_images/avatar.png'
import Actions from './Actions'
import { handleFileChange, fetchUGhubToken, fetchJsonToken, handleAuthorize, getUserInfo } from '../../_utils'
import { CircularProgress } from '@material-ui/core'
// import useFetchUghubToken from '../../_hooks/useFetchUghubToken'
import { Formik } from 'formik'

const menuItems = [
  "Applicant Particulars",
  "Location Particulars",
  "Business Particulars",
  "Attachments",
  "Application Trail",
  "Action"
]

const ValField = record => {
  if (record.value instanceof Array) {
    return (
      <div>{`1`}</div>
    )
  }
  else {
    return (
      <div className="text-gray-500">
        {record.value}
      </div>
    )
  }
}

export default function () {
  const ref = useRef(null);
  // const getToken = useFetchUghubToken()

  const state = useSelector(state => {
    return {
      verifyFlag: state.application.verifyModal?.verifyFlag,
      title: state.application.verifyModal?.title,
    }
  })
  const Columns = useMemo(() =>
    [
      {
        Header: "Parameter",
        accessor: "label",
        sortable: false
      },
      {
        Header: "Information",
        accessor: "value",
        sortable: false,
        Cell: ValField
      }
    ])

  const DefaultColumns = useMemo(() =>
    [
      {
        Header: "Parameter",
        accessor: "label",
        sortable: false
      },
      {
        Header: "Information",
        accessor: "value",
        sortable: false,
        Cell: ValField
      },
      {
        Header: "Attachment",
        accessor: "attachment",
        sortable: false
      },
      {
        Header: "Status",
        accessor: "attachment_status",
        sortable: false
      },

    ])

  const [initLoading, setInitLoading] = React.useState(true)
  const [record, setRecord] = useState(null)
  const [records, setRecords] = React.useState([])
  const [currentLink, setCurrentLink] = useState("Applicant Particulars")
  const [remarks, setRemarks] = useState([])
  const [files, setFiles] = useState([])
  const [previousSystemDoc, setPreviousSystemDoc] = useState("")
  const [previousSystemFiles, setPreviousSystemFiles] = useState([])
  const [auditReport, setAuditReport] = useState([])
  const [showAuditReport, setShowAuditReport] = useState(false)
  const [securityReport, setSecurityReport] = useState([])
  const [showSecurityClearanceReport, setShowSecurityClearanceReport] = useState(false)
  const [QAReport, setQAReport] = useState([])
  const [showQAReport, setShowQAReport] = useState(false)
  const [showUploadNewDoc, setShowUploadNewDoc] = useState(false)
  const [docSlug, setDocSlug] = useState("")
  const [signedWithUgPass, setSignedWithUgPass] = useState(false)
  const [showEmailUpdateModal, setShowEmailUpdateModal] = useState(false)
  const [showEntityNameUpdateModal, setShowEntityNameUpdateModal] = useState(false)
  const [auditors, setAuditors] = useState([])


  const [loading, setLoading] = React.useState(false)
  const [fetchedToken, setToken] = useState(null)
  const [accessData, setAccessData] = useState(null)
  const [userInfo, setUserInfo] = useState(null)
  const [fetching, setFetching] = useState(false)
  const [document, setDocument] = useState(null)
  const [signLoading, setSignLoading] = useState(false)
  const [signedResult, setSignedResult] = useState(null)
  const [circularLoading, setCircularLoading] = React.useState(false)
  const [uploadedExpProof, setUploadedExpProof] = useState({})
  const [selectedFiles, setSelectedFiles] = useState([]);

  React.useEffect(() => {
    if (initLoading) {
      fetchApplication()
      fetchAllRemarks()
      fetchAllDocuments()
      fetchSignedUgPassDocs()
      fetchAllPreviousSystemDocuments()
      fetchAuditReport()
      fetchSecurityReport()
      fetchQAReport()
      setLoading(true)
    }
  }, [initLoading])

  React.useEffect(() => {
    if (userInfo) {
      setFetching(false)
    }
  }, [userInfo])

  React.useEffect(() => {
    if (loading) {

      const checkUgPass = async () => {
        let ugpass = await localStorage.getItem("ugpass_access")
        if (ugpass) {
          fetchUGhubToken(async (result) => {
            if (result) {
              //set state token
              await setToken(result)
              await setLoading(false)
            }
          }, error => {
            console.error(error)
            setLoading(false)
          })
        }
        else {
          setLoading(false)
        }
      }

      checkUgPass()
    }
  }, [loading])

  const toggleFileSelection = (id) => {
    setSelectedFiles(prev =>
      prev.includes(id) ? prev.filter(fileId => fileId !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    if (selectedFiles.length === files.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(files.map(file => file.id));
    }
  };

  const deleteSelectedFiles = async () => {
    if (!window.confirm("Are you sure you want to delete the selected files?")) return;

    try {
      const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/delete_multiple_documents`, {
        file_ids: selectedFiles
      });

      if (response.data) {
        alert(response.data.message);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      alert("Failed to delete selected files.");
    }
  };

  const handleNewFileUpload = async (values) => {
    await setCircularLoading(true)

    let description = values?.description

    const data = new FormData()

    data.append("file", uploadedExpProof.document)
    //data.append( "name", uploadedExpProof.name )
    data.append("name", description)
    data.append("title", description)
    data.append("type", uploadedExpProof.type)
    data.append("size", uploadedExpProof.size)
    data.append("application_id", record?.id)
    data.append("description", description)
    data.append("created_by", localStorage.getItem("email"))

    try {
      const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/addITDocuments`, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      if (response.data) {
        await setShowUploadNewDoc(false)
        alert(response.data.message)
        console.log(response.data)
        return window.location.reload()
        await setCircularLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleFileBlur = (evt) => {
    let savedFile = {
      file: uploadedExpProof.document,
      title: uploadedExpProof.name,
      size: uploadedExpProof.size,
      tag: uploadedExpProof.tag,
      type: uploadedExpProof.type,
    }

    let data = Object.assign({}, savedFile)

    //dispatch(  setExperienceProofFiles( {experienceProofFiles: [ ...state.experienceProofFiles, data ] }) )
  }

  const handleFile = (evt, tag) => {
    handleFileChange(evt, tag, (response, file) => {
      if (file.size > 6128180) {
        alert("Please make sure that the file size doesn't exceed 5 MBs")
      } else {
        setUploadedExpProof({
          document: response,
          name: file.name,
          size: file.size,
          tag: tag,
          type: file.type
        })
      }
    })
    console.log(uploadedExpProof.document)
  }




  const handleSigning = async () => {
    if (!loading) {
      setSignLoading(true)
      let data = new FormData();
      let access = JSON.parse(localStorage.getItem("accessToken"))
      let user = JSON.parse(localStorage.getItem("user_info"))
      let subId = String(user?.daes_claims?.suid)

      let model = {
        documentType: "PADES",
        subscriberUniqueId: subId,
        placeHolderCoordinates: {
          pageNumber: 1,
          signatureXaxis: 400.00,
          signatureYaxis: 650.00
        }
      }

      data.append("model", JSON.stringify(model))
      data.append("token", fetchedToken.data.access_token)
      data.append("accessToken", access?.access_token)
      data.append("applicationId", parseInt(localStorage.getItem("applicationId")))
      data.append("subscriberId", subId)

      //send file up for signing
      try {
        const response = await Axios.post(`https://api.cert.works.go.ug/api/auth/ugpass_payload`, data)
        if (response.data) {
          console.log("signing doc====")
          console.log(response.data)
          alert(response.data?.response?.message)
          setSignedResult(response.data?.response)
          setSignLoading(false)
        }
      } catch (error) {
        console.log("errrorr logged below=>")
        console.log(error)
        if (error.response?.data) {
          alert(error.response?.data?.message)
        }
        else {
          console.log(error)
          alert("Something went wrong while signing / Timeout exceeded...try again")
        }

        setSignLoading(false)
      }
    }
  }

  const fetchApplication = async () => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/itcoapplication/${localStorage.getItem("applicationId")}`)
      if (response.data) {
        setRecord(response.data.record)
        setInitLoading(false)
      }
    } catch (error) {
      setInitLoading(false)
    }
  }

  const fetchAllRemarks = async () => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getAllITRemarks`)
      if (response.data) {
        const results = response.data.filter(remark => {
          return parseInt(remark.parentID) === parseInt(localStorage.getItem("applicationId"));
        })
        setRemarks(results);
      }
    } catch (error) {

    }
  }

  const fetchAllDocuments = async () => {
    let applicationId = localStorage.getItem("applicationId")
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getApplicationFiles/${applicationId}`)
      if (response.data) {
        setFiles(response.data?.data)
      }
    } catch (error) { }
  }

  const fetchSignedUgPassDocs = async () => {
    let applicationId = localStorage.getItem("applicationId")
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getSignedCertificate/${applicationId}`)
      if (response.data) {
        if (response.data.signed) {
          setSignedWithUgPass(response.data)
        }
      }
    } catch (error) { }
  }

  const fetchAllPreviousSystemDocuments = async () => {
    let applicationId = localStorage.getItem("applicationId")
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getPreviousSystemApplicationFiles/${applicationId}`)
      if (response.data) {
        console.log(response.data)
        setPreviousSystemFiles(response.data?.data)
      }
    } catch (error) { }
  }

  const fetchAuditReport = async () => {
    let applicationId = localStorage.getItem("applicationId")
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getAuditReport/${applicationId}`)
      if (response.data) {
        setAuditReport(response.data)
      }
    } catch (error) { }
  }

  const fetchSecurityReport = async () => {
    let applicationId = localStorage.getItem("applicationId")
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getSecurityReport/${applicationId}`)
      if (response.data) {
        setSecurityReport(response.data)
      }
    } catch (error) { }
  }

  const fetchQAReport = async () => {
    let applicationId = localStorage.getItem("applicationId")
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getQualityAssuranceReport/${applicationId}`)
      if (response.data) {
        setQAReport(response.data)
      }
    } catch (error) { }
  }

  const printCertificate = async () => {
    let applicationId = localStorage.getItem("applicationId")
    let itcoArray = [{ "3j4kndd": applicationId }]
    let mySerializedString = JSON.stringify(itcoArray);
    try {
      const url = process.env.REACT_APP_API_URL + `/api/auth/print_certificate/${mySerializedString}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) { console.log("failed after getting model") }
  }

  const attachSigatureToCertificate = async () => {
    /*
    - hit the UG Pass end point to get body, model, etc
    - use the response body, model etc from the UGPass to attach to payload with the certificate PDF and back to UGPass 
    */
    try {
      const response = await Axios.get(`https://signservice.works.go.ug`)
      if (response.data) {
        let body = response.data.body
        let model = response.data.model

        let applicationId = localStorage.getItem("applicationId")
        let itcoArray = [{ "3j4kndd": applicationId }]
        let mySerializedString = JSON.stringify(itcoArray);
        try {
          const url = process.env.REACT_APP_API_URL + `/api/auth/print_certificate/${mySerializedString}`
          const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
          if (newWindow) newWindow.opener = null
        } catch (error) { console.log("failed after getting model") }
      }
    } catch (error) { console.log(error) }
  }

  const fetchAllUsers = async () => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/itcouser`)

      const results = (response.data?.records || [])
        .filter(user => user.user_role?.toUpperCase().includes("APPLICANT"))
        .map((result) => {
          const email = result.email || result.email_address
          return {
            id: result.id,
            label: `${email} (${result.domain || "UG"})`,
            value: email
          }
        })
        .filter(entry => entry.value)

      setAuditors(results)
    } catch (error) {
      alert("Server error occurred.")
    }
  }

  const handleUpdateApplicationEmail = async (values) => {
    const application_to_update = localStorage.getItem("applicationId")

    if (!application_to_update) {
      alert("Application not found.")
      return
    }

    if (!values.assigned_email) {
      alert("Please select an email address.")
      return
    }

    try {
      const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/update_application_email`, {
        application_id: application_to_update,
        assigned_email: values.assigned_email,
        actioned_by: localStorage.getItem("email")
      })

      if (response.data?.success === false) {
        alert(response.data.message || "Failed to update email.")
        return
      }

      if (response.data) {
        alert(response.data.message)
        setShowEmailUpdateModal(false)
        return window.location.reload()
      }
    } catch (error) {
      const message = error.response?.data?.message
        || (error.response?.data?.errors
          ? Object.values(error.response.data.errors).flat().join(", ")
          : "Failed to update application email.")
      alert(message)
      console.log(error)
    }
  }

  const handleUpdateEntityName = async (values) => {
    const application_to_update = localStorage.getItem("applicationId")

    if (!application_to_update) {
      alert("Application not found.")
      return
    }

    const nextEntityName = (values?.entity_name || "").trim()
    if (!nextEntityName) {
      alert("Please enter an entity name.")
      return
    }

    try {
      const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/update_entity_name`, {
        application_id: application_to_update,
        entity_name: nextEntityName,
        actioned_by: localStorage.getItem("email")
      })

      if (response.data?.success === false) {
        alert(response.data.message || "Failed to update entity name.")
        return
      }

      if (response.data) {
        alert(response.data.message)
        setShowEntityNameUpdateModal(false)
        return window.location.reload()
      }
    } catch (error) {
      const message = error.response?.data?.message
        || (error.response?.data?.errors
          ? Object.values(error.response.data.errors).flat().join(", ")
          : "Failed to update entity name.")
      alert(message)
      console.log(error)
    }
  }

  const previewFile = async (e) => {
    let file_id = e.target.id

    try {
      const email = btoa(localStorage.getItem("email")); // Base64 encode
      const url = process.env.REACT_APP_API_URL + `/api/auth/get_file_details/${file_id}/${email}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) { }
  }

  const DeleteFile = async (e) => {
    let file_id = e.target.id

    if (window.confirm("Are you sure you want to delete this file ?") == true) {
      try {
        const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/delete_application_document`, { file_id: file_id })
        if (response.data) {
          alert(response.data.message)
          return window.location.reload()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const viewPreviousSystemDoc = async (entity_name, docSlug) => {
    // console.log("go to the basket =>>"+docSlug)
    // console.log("go to the basket =>>"+entity_name)
    try {
      const url = process.env.REACT_APP_API_URL + `/api/auth/view_previous_system_doc/${docSlug}/${entity_name}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) { }
  }


  const handleFiles = (evt) => {
    if (evt.target.files?.length > 0) {
      setDocument(evt.target.files[0])
    }
  }

  const handleClick = (dataURI) => {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'application/pdf' });
    return blob;
  }

  const downloadPDF = () => {
    if (signedResult) {
      const blob = handleClick(signedResult?.result)
      const url = URL.createObjectURL(blob)
      window.open(url, "_blank")
    }
    else {
      return alert("No file to download")
    }

  }


  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <span>{`Loading`}</span>
        <CircularProgress size={24} color="primary" />
      </div>
    )
  }

  console.log("ughub token", fetchedToken)
  console.log("signed result", signedResult)

  return (
    <Wrapper>
      {initLoading ? (
        <div className="flex items-center justify h-full w-full">
          {`Loading...`}
        </div>
      )
        : (
          <div className="bg-gray-100 h-full overflow-y-scroll grid gap-3 px-10 py-3" style={{ gridTemplateColumns: "3fr 1fr" }}>

            <div className="h-full bg-white rounded-sm grid" style={{ gridTemplateRows: ".5fr 1fr 4fr" }}>
              <div className="border-b border-gray-300 flex flex-row">
                <div className="flex flex-row items-center px-2">
                  {/* <button className="text-sm underline text-red-500" onClick={() => alert("back")}>Back</button> */}
                  <h2 className="p-5 text-sm font-bold uppercase">
                    {`Application Information`}
                  </h2>
                </div>
                <div />
              </div>

              <div className="border-b border-gray-300 p-4">
                <div className="h-full border border-gray-200 flex flex-row items-center justify-between rounded-sm">
                  <div className="grid gap-2 px-2" style={{ gridTemplateRows: "1rem auto" }}>
                    <h5 className="text-start text-xs uppercase">
                      {`Applicant`}
                    </h5>
                    <div className="flex flex-row px-2">
                      <div className="rounded-full border border-gray-200 overflow-hidden flex items-center justify-center w-10 h-10">
                        <img src={avatar} alt="Profile Image" className="rounded-full" />
                      </div>
                      <div className="flex flex-col items-start justify-center px-2">
                        <p className="text-xs">
                          {/* {capitalizeName( record?.first_name + " " +  record?.surname )} */}
                        </p>
                        <p className="text-xs">
                          {/* {record?.telephone} */}
                        </p>
                        <p className="text-xs">
                          {/* {record?.email_address} */}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-center">
                    <div>
                      <div className="flex flex-row items-center">
                        <TextDetail label="Entity Name" val={record?.entity_name} />
                        <FaEdit
                          className="cursor-pointer ml-2 hover:text-blue-500"
                          onClick={() => setShowEntityNameUpdateModal(true)}
                        />
                      </div>

                      <div className="flex flex-row items-center">
                        <TextDetail label="Client Email Address" val={record?.created_by} />
                        <FaEdit className="cursor-pointer ml-2 hover:text-blue-500" onClick={() => {
                          setShowEmailUpdateModal(true)
                          fetchAllUsers()
                        }} />
                      </div>
                      <TextDetail label="Category" val={record?.category} />
                      <TextDetail label="Applied On" val={moment(record?.created_at).format("DD MMM, YYYY HH:mm:ss")} />
                      <TextDetail label="Payment" val={(record?.prn_status === "C" ? "Submitted And Cleared" : "NOT CLEARED")} />{/* RECEIVED AND CREDITED */}
                      {(signedWithUgPass ? <TextDetail label="Application Status" val={"SIGNED"} color="green" /> :
                        <TextDetail label="Application Status" val={record?.status || "ONGOING"} color="blue" />
                      )}
                    </div>
                  </div>
                  <div />
                </div>
              </div>

              <div className="w-full">

                {(record?.status?.toUpperCase() === "APPROVED" && localStorage.getItem("role")?.toUpperCase() === "APPROVER") &&
                  signLoading ? (
                  <div className="flex items-center justify-center">
                    <CircularProgress size={24} color="primary" />
                    <span>{`Loading Signing...`}</span>
                  </div>
                ) :
                  <div className="w-full h-auto my-2">
                    {(!(signedResult?.result) && ((record?.status?.toUpperCase() === "APPROVED" && localStorage.getItem("role")?.toUpperCase() === "APPROVER"))) &&
                      (<>
                        {/* <button type="button" className="rounded text-sm bg-purple-700 text-white py-1 m-1 px-2" onClick={handleSigning}>
                          {`Attach Signature`}
                        </button> */}
                      </>
                      )}
                  </div>}

                {currentLink === "Applicant Particulars" && (
                  <>
                    <Panel label="Section A: Applicant Particulars">
                      <div className="grid grid-cols-2 gap-2 items-center">
                        {record?.category === "Individual" && [
                          { label: "Category", value: record?.category, name: "category" },
                          { label: "Given Name/ First Name", value: record?.given_name, name: "given_name" },
                          { label: "Surname", value: record?.surname, name: "surname" },
                          { label: "Other Name", value: record?.middle_name, name: "other_name" },
                          { label: "Nationality", value: record?.nationality, name: "nationality" },
                          { label: record?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: record?.nationality === "Ugandan" ? record?.national_id : record?.passport_number, name: "national_id" },
                          { label: "Taxpayer Identification Number", value: record?.tin, name: "tin" }
                        ].map(val => {
                          return (
                            <TextField
                              name={val.name}
                              label={val.label}
                              value={val.value}
                              key={val.value}
                            />
                          )
                        })}

                        {record?.category === "Company" && [
                          { label: "Certification Level", value: record?.certification_level, name: "certification_level" },
                          { label: "Contact First Name", value: record?.contact_first_name, name: "contact_first_name" },
                          { label: "Contact Last Name", value: record?.contact_last_name, name: "contact_last_name" },
                          { label: "Other Name", value: record?.contact_middle_name, name: "contact_middle_name" },
                          { label: "TIN", value: record?.tin, name: "tin" },
                        ].map(val => {
                          return (
                            <TextField
                              name={val.name}
                              label={val.label}
                              value={val.value}
                              key={val.value}
                            />
                          )
                        })}
                      </div>
                    </Panel>
                  </>
                )}

                {currentLink === "Location Particulars" && (
                  <Panel label="Section A: Location Particulars">
                    <div className="grid grid-cols-2 gap-2 items-center">
                      {[
                        { label: "District", value: record?.district, name: "district" },
                        { label: "County", value: record?.county, name: "county" },
                        { label: "Subcounty", value: record?.subcounty, name: "subcounty" },
                        { label: "Parish", value: record?.parish, name: "parish" },
                        { label: "Village", value: record?.village, name: "village" }
                      ].map(val => {
                        return (
                          <TextField
                            name={val.name}
                            label={val.label}
                            value={val.value}
                            key={val.value}
                          />
                        )
                      })}
                    </div>
                  </Panel>
                )}

                {currentLink === "Business Particulars" && (
                  <Panel label="Section B: Business Particulars">
                    <div className="grid grid-cols-2 gap-2 items-center">
                      {[
                        { label: "Date of Incorporation", value: record?.doc, name: "doc" },
                        { label: "Name of Entity", value: record?.entity_name, name: "entity_name" },
                        { label: "Entity Registration", value: record?.entity_registration, name: "entity_registration" },
                        { label: "Entity Type", value: record?.entity_type, name: "entity_type" },
                        { label: "BRN", value: record?.ern, name: "ern" },
                        { label: "Membership", value: record?.membership, name: "membership" },
                        { label: "# Females", value: record?.no_females, name: "no_females" },
                        { label: "# Males", value: record?.no_males, name: "no_males" },
                        { label: "Service Type", value: record?.service_type, name: "service_type" },
                        { label: "Business Trading Name", value: record?.trading_name, name: "trading_name" },
                        { label: "Annual Turnover / Income", value: record?.annual_turnover, name: "annual_turnover" },
                        { label: "Website", value: record?.website, name: "website" },
                      ].map(val => {
                        return (
                          <TextField
                            name={val.name}
                            label={val.label}
                            value={val.value}
                            key={val.value}
                          />
                        )
                      })}
                    </div>
                  </Panel>
                )}

                {currentLink === "Attachments" && (
                  <Panel label="Attachments">
                    <table className="w-full border">
                      <thead className="text-xs bg-gray-200 font-bold p-2">
                        <th className="p-2">#</th>
                        <th>Name</th>
                        <th>Size</th>
                        <th>Action</th>
                        <th className="p-2">
                          <input type="checkbox" onChange={toggleSelectAll} />
                        </th>
                        <th>Date Created</th>
                      </thead>
                      <tbody>
                        {files?.map((item, index) => {
                          return (
                            <tr className="text-xs p-2 text-center">
                              <td className="p-2">{`${index + 1}`}</td>
                              {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                              <td>{item.name}</td>
                              <td>{item.size}</td>
                              <td>
                                {/* <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a> */}
                                <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a>
                                <a className="bg-red-800 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={DeleteFile}>Delete</a>
                              </td>
                              <td className="p-2">
                                <input
                                  type="checkbox"
                                  checked={selectedFiles.includes(item.id)}
                                  onChange={() => toggleFileSelection(item.id)}
                                />
                              </td>
                              <td>{moment(item.created_at).format("DD MMM, YYYY HH:mm:ss")}</td>
                            </tr>
                          )
                        })}

                        {previousSystemFiles?.map((item, index) => {
                          return (
                            <>
                              {item.trading_licence_doc !== "" &&
                                <tr className="text-xs p-2 text-center">
                                  <td className="p-2">{`${index + 1}`}</td>
                                  {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                                  <td>{item.trading_licence_doc} </td>
                                  <td></td>
                                  <td>
                                    <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={(e) => { setDocSlug("trading_licence_doc"); viewPreviousSystemDoc(item.business_trading_name, "trading_licence_doc"); }}>View</a>
                                    {/* <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a> */}
                                  </td>
                                  <td>{moment(item.date_created).format("DD MMM, YYYY")}</td>
                                </tr>
                              }

                              {item.it_experience_doc &&
                                <tr className="text-xs p-2 text-center">
                                  <td className="p-2">{`${index + 1}`}</td>
                                  {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                                  <td>{item.it_experience_doc}</td>
                                  <td></td>
                                  <td>
                                    <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={(e) => { setDocSlug("it_experience_doc"); viewPreviousSystemDoc(item.business_trading_name, "it_experience_doc"); }}>View</a>
                                    {/* <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a> */}
                                  </td>
                                  <td>{moment(item.date_created).format("DD MMM, YYYY")}</td>
                                </tr>
                              }

                              {item.income_tax_clearance_doc &&
                                <tr className="text-xs p-2 text-center">
                                  <td className="p-2">{`${index + 1}`}</td>
                                  {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                                  <td>{item.income_tax_clearance_doc}</td>
                                  <td></td>
                                  <td>
                                    <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={(e) => { setDocSlug("income_tax_clearance_doc"); viewPreviousSystemDoc(item.business_trading_name, "income_tax_clearance_doc"); }}>View</a>
                                    {/* <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a> */}
                                  </td>
                                  <td>{moment(item.date_created).format("DD MMM, YYYY")}</td>
                                </tr>
                              }
                            </>
                          )
                        })}
                      </tbody>
                    </table>
                    <div className="flex justify-between">
                      <button onClick={async () => {
                        setShowUploadNewDoc(true)
                      }} className="pr-10 bg-amber-600 text-white p-1 m-2 rounded-sm">Upload new document</button>

                      <button
                        disabled={selectedFiles.length === 0}
                        onClick={deleteSelectedFiles}
                        className="bg-red-700 text-white p-1 m-2 rounded-sm"
                      >
                        Delete Selected Files
                      </button>
                    </div>
                  </Panel>
                )}

                {currentLink === "Application Trail" && (
                  <table className="w-full border">
                    <thead className="text-xs bg-gray-200 font-bold p-2">
                      <th className="p-2">#</th>
                      <th>Actor</th>
                      <th>Comments</th>
                      <th>Action</th>
                      <th>Date Created</th>
                    </thead>
                    <tbody>
                      {remarks?.filter(record => {
                        return record.role !== null
                      }).map((item, index) => {
                        return (
                          (item.role == "FINANCE") ?
                            <tr className="text-xs p-2 text-center">
                              <td className="p-2">{`${index + 1}`}</td>
                              <td>{item.actioned_by}</td>
                              <td>{item.comments ?? "Approved"}</td>
                              <td>{item.role == 'VERIFIER,AUDITOR' ? 'Audited' : item.action}</td>
                              <td>{moment(item.created_at).format("DD MMM, YYYY HH:mm:ss")}</td>
                            </tr> :
                            (item.comments !== null) && (
                              <tr className="text-xs p-2 text-center">
                                <td className="p-2">{`${index + 1}`}</td>
                                <td>{item.actioned_by}</td>
                                <td>{item.comments}</td>
                                <td>{item.role == 'VERIFIER,AUDITOR' ? 'Audited' : item.action}</td>
                                <td>{moment(item.created_at).format("DD MMM, YYYY HH:mm:ss")}</td>
                              </tr>)
                        )
                      })}

                      {record?.stage > 4 &&
                        <tr>
                          <td colSpan={5}>
                            <button onClick={async () => {
                              setShowAuditReport(true)
                            }} className="text-xs bg-blue-700 text-white px-2 py-1 ml-5" type="button">
                              {`View Audit Report`}
                            </button>
                          </td>
                        </tr>
                      }

                      {record?.security_clearance_form == 1 &&
                        <tr>
                          <td colSpan={5}>
                            <button onClick={async () => {
                              setShowSecurityClearanceReport(true)
                            }} className="text-xs bg-blue-400 text-white px-2 py-1 ml-5" type="button">
                              {`View Security Clearance Report`}
                            </button>
                          </td>
                        </tr>
                      }

                      {record?.stage > 5 &&
                        <tr>
                          <td colSpan={5}>
                            <button onClick={async () => {
                              setShowQAReport(true)
                            }} className="text-xs bg-green-700 text-white px-2 py-1 ml-5" type="button">
                              {`View Quality Assurance Report`}
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                )}


                {currentLink === "Action" && (
                  <Actions result={record} />
                )}

              </div>
            </div>

            <div className="h-1/4 bg-white rounded-md shadow-xl">
              <div className="flex flex-col justify-center">
                <div className="border-b border-gray-300">
                  <h2 className="px-4 py-5 text-xs font-bold uppercase">
                    {`Account`}
                  </h2>
                </div>
                {menuItems.map(link => {
                  return (
                    <ListItem
                      icon={<FaAddressCard color="white" />}
                      key={link}
                      label={link}
                      handlePress={() => setCurrentLink(link)}
                      active={currentLink === link} />
                  )
                })}

              </div>
            </div>
          </div>)}

      <ModalComponent title={`Security Clearance Report`} open={showSecurityClearanceReport}>
        <div className="flex flex-col items-center justify-center">
          <table className="text-gray-700 py-1 text-xs border-collapse mt-2 table-fixed overflow-x-scroll">
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Code of conduct (for your staff) detailing written collection of the rules, principles, values and employee expectations, behavior, and relationships that the organization considers significant and believes are fundamental to its successful operations</th>
              <td className="border border-slate-300">{securityReport?.code_of_conduct}</td>
              <td className="border border-slate-300">{securityReport?.code_of_conduct_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Terms or conditions of agreement, including any guarantees, that apply to your systems</th>
              <td className="border border-slate-300">{securityReport?.terms_of_conditions_of_agreement}</td>
              <td className="border border-slate-300">{securityReport?.terms_of_conditions_of_agreement_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Code of Staff confidentiality & non-disclosure agreements</th>
              <td className="border border-slate-300">{securityReport?.staff_confidentiality_and_non_disclosure}</td>
              <td className="border border-slate-300">{securityReport?.staff_confidentiality_and_non_disclosure_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Data retention mechanism/policy</th>
              <td className="border border-slate-300">{securityReport?.data_retention_mechanism}</td>
              <td className="border border-slate-300">{securityReport?.data_retention_mechanism_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Internal information security awareness for staff</th>
              <td className="border border-slate-300">{securityReport?.internal_information_security_awareness}</td>
              <td className="border border-slate-300">{securityReport?.internal_information_security_awareness_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Information Security policy</th>
              <td className="border border-slate-300">{securityReport?.information_security_policy}</td>
              <td className="border border-slate-300">{securityReport?.information_security_policy_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Data protection and privacy policy</th>
              <td className="border border-slate-300">{securityReport?.data_protection_and_privacy}</td>
              <td className="border border-slate-300">{securityReport?.data_protection_and_privacy_comment}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Action</th>
              <td className="border border-slate-300" colSpan={2}>{securityReport?.action}</td>
            </tr>

            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Actioned By</th>
              <td className="border border-slate-300" colSpan={2}>{securityReport?.created_by}</td>
            </tr>
          </table>

          <button onClick={async () => {
            setShowSecurityClearanceReport(false)
          }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>

      <ModalComponent title={`Audit Report`} open={showAuditReport}>
        <div className="overflow-auto w-full max-w-full">
          <table className="min-w-full text-gray-700 border-collapse">
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Type of Audit</th>
              <td className="border border-slate-300">{auditReport?.type_of_audit}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Applicable Regulation</th>
              <td className="border border-slate-300">{auditReport?.applicable_regulation || "NITA-U (Certification of Providers of IT Products and Services) (Amendment) Regulation 2018"}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Applicable Standard(s)</th>
              <td className="border border-slate-300">{auditReport?.applicable_standard}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">ISIC Codes</th>
              <td className="border border-slate-300">{auditReport?.isic_codes}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Audit Site</th>
              <td className="border border-slate-300">{auditReport?.audit_site}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Audit Date</th>
              <td className="border border-slate-300">{auditReport?.audit_date}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Distribution/Confidentiality/Rights of <br />bownership/Limitations/Responsibilities</th>
              <td className="border border-slate-300">{auditReport?.distribution_limitations_responsibilties}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Audit Criteria</th>
              <td className="border border-slate-300">{auditReport?.audit_criteria}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Proof of Legal Status</th>
              <td className="border border-slate-300">
                {auditReport?.proof_of_legal_status}<br />
                - <b>{auditReport?.proof_of_legal_status_comment}</b>
              </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Proof of registration for <br />tax purposes</th>
              <td className="border border-slate-300">
                {auditReport?.proof_of_registration}<br />
                - <b>{auditReport?.proof_of_registration_comment}</b>
              </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Proof of Office location and <br />necessary facilities, equipment <br />and infrastructure</th>
              <td className="border border-slate-300">
                {auditReport?.proof_of_office_location}<br />
                - <b>{auditReport?.proof_of_office_location_comment}</b>
              </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Proof of IT Personnel used to <br />provide IT Services</th>
              <td className="border border-slate-300">
                {auditReport?.proof_of_it_personnel}<br />
                - <b>{auditReport?.proof_of_it_personnel_comment}</b>
              </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Proof of applicable quality<br /> and technical manuals</th>
              <td className="border border-slate-300">
                {auditReport?.proof_of_manuals}<br />
                - <b>{auditReport?.proof_of_manuals_comment}</b>
              </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Proof of satisfactory past services<br /> provided in the field of IT service/product<br /> for which certification is sought</th>
              <td className="border border-slate-300">
                {auditReport?.proof_of_past_services}<br />
                - <b>{auditReport?.proof_of_past_services_comment}</b>
              </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Audit Notes</th>
              <td className="border border-slate-300">{auditReport?.audit_notes} </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Auditee Members</th>
              <td className="border border-slate-300">{auditReport?.auditee_members} </td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Report added on</th>
              <td className="border border-slate-300">{moment(auditReport?.created_at).format("DD MMM, YYYY HH:mm:ss")}</td>
            </tr>
          </table>

          <button onClick={async () => {
            setShowAuditReport(false)
          }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>

      <ModalComponent title={`Quality Assurance Report`} open={showQAReport}>
        <div className="flex flex-col items-center justify-center">
          <table className="text-gray-700 py-1 text-xs border-collapse mt-2 table-fixed overflow-x-scroll">
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Level of certification applied (Should <br />  be same as on the Certificate)</th>
              <td className="border border-slate-300 px-2"> {QAReport?.level_of_certification_compliance}</td>
              <td className="border border-slate-300 px-2"> {QAReport?.level_of_certification_remarks}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">All required documentation are on file</th>
              <td className="border border-slate-300 px-2"> {QAReport?.required_documents_compliance}</td>
              <td className="border border-slate-300 px-2"> {QAReport?.required_documents_remarks}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Audit report complete in alignment with<br /> the IT Certification requirements</th>
              <td className="border border-slate-300 px-2"> {QAReport?.audit_report_complete_compliance}</td>
              <td className="border border-slate-300 px-2"> {QAReport?.audit_report_complete_remarks}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Payment of the required fees made</th>
              <td className="border border-slate-300 px-2"> {QAReport?.payment_of_fees_compliance}</td>
              <td className="border border-slate-300 px-2"> {QAReport?.payment_of_fees_remarks}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Domain applied for in line with Company Competence</th>
              <td className="border border-slate-300 px-2"> {QAReport?.domain_applied_for_compliance}</td>
              <td className="border border-slate-300 px-2"> {QAReport?.domain_applied_for_remarks}</td>
            </tr>
            <tr className="text-xs p-2 text-left">
              <th className="border border-slate-300 p-1">Certification level</th>
              <td className="border border-slate-300 px-2"> {QAReport?.certification_level_compliance}</td>
              <td className="border border-slate-300 px-2"> {QAReport?.certification_level_remarks}</td>
            </tr>
          </table>

          <button onClick={async () => {
            setShowQAReport(false)
          }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>

      <ModalComponent title={`Upload new client document`} open={showUploadNewDoc}>
        <Panel label="Upload New Client Document">
          <div className="flex flex-col items-start justify-center px-5 py-2">
            <Formik initialValues={{
              actioned_by: localStorage.getItem("username")
            }} onSubmit={handleNewFileUpload}>
              {({ handleSubmit, handleBlur, handleChange, values }) => {
                return (
                  <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                    <div className="w-full grid grid-rows-2 gap-1">
                      <TextFieldIcon
                        name="description"
                        handleChange={evt => {
                          handleChange(evt)
                        }}
                        handleBlur={handleBlur}
                        value={values.description}
                        iconComponent={<FaAddressCard color={`#AFC836`} />}
                        label="File Description"
                        required={true}
                        question="File Description" />

                      <FileFieldIcon
                        noPadding
                        name="client_document"
                        handleBlur={evt => {
                          handleBlur(evt)
                          handleFileBlur(evt)
                        }}
                        handleChange={evt => {
                          handleChange(evt)
                          handleFile(evt, "client_document")
                        }}
                        iconComponent={<FaUserAlt color={`#666`} />}
                        label="Client Document"
                        question="Client Document"
                        required={true}
                        tooltip=""
                        tooltipExplanation="Attach any document that was missed by client E.g Contract, LPO, Certificate etc"
                      />
                    </div>

                    {circularLoading ? (
                      <div className="flex items-center justify-center">
                        <CircularProgress size={24} color="primary" />
                      </div>
                    ) :
                      (
                        <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                          {`Submit`}
                        </button>
                      )}
                  </form>
                )
              }}
            </Formik>
          </div>
        </Panel>
        <div className="flex flex-col items-center justify-center">
          <button onClick={async () => {
            setShowUploadNewDoc(false)
          }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>

      <ModalComponent title={`Update Application Email`} open={showEmailUpdateModal}>
        <div className="flex flex-col items-center justify-center text-sm">
          <div className="flex flex-row">
            <Panel label="Update Application Email" className="gap-2">
              <div className="grid grid-cols-2 gap-2 items-center">
                Trading Name:{record?.trading_name}
              </div>

              <Formik
                enableReinitialize
                initialValues={{
                  assigned_email: record?.created_by || "",
                  actioned_by: localStorage.getItem("email") || "",
                }}
                onSubmit={handleUpdateApplicationEmail}
              >
                {({ handleSubmit, isSubmitting }) => {
                  return (
                    <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                      <SearchableSelectField
                        name="assigned_email"
                        required={true}
                        disabled={false}
                        options={auditors.map(({ id, label, value }) => {
                          return { id, label, value }
                        })}
                        question="Select Email" />

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#278556] text-xs text-white flex items-center justify-center disabled:opacity-50"
                      >
                        Submit
                      </button>
                    </form>
                  )
                }}
              </Formik>
            </Panel>
          </div>
          <button onClick={async () => {
            setShowEmailUpdateModal(false)
          }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>

      <ModalComponent title={`Update Entity Name`} open={showEntityNameUpdateModal}>
        <div className="flex flex-col items-center justify-center text-sm">
          <div className="flex flex-row">
            <Panel label="Update Entity Name" className="gap-2">
              <div className="grid grid-cols-2 gap-2 items-center">
                Trading Name:{record?.trading_name}
              </div>

              <Formik
                enableReinitialize
                initialValues={{
                  entity_name: record?.entity_name || "",
                  actioned_by: localStorage.getItem("email") || "",
                }}
                onSubmit={handleUpdateEntityName}
              >
                {({ handleSubmit, isSubmitting, values, handleChange }) => {
                  return (
                    <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>
                      <label className="text-xs font-bold">{`Entity Name`}</label>
                      <input
                        name="entity_name"
                        value={values.entity_name}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 rounded px-2 py-1 text-sm my-2"
                        placeholder="Enter entity name"
                      />

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#278556] text-xs text-white flex items-center justify-center disabled:opacity-50"
                      >
                        Submit
                      </button>
                    </form>
                  )
                }}
              </Formik>
            </Panel>
          </div>
          <button onClick={async () => {
            setShowEntityNameUpdateModal(false)
          }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>
    </Wrapper>
  )
}
